import { Flex, TextV2 } from '@withjoy/joykit';
import React from 'react';
import type { AccommodationListingDTO } from '@shared/types/Accommodations.types';
import { pxToRem } from '@withjoy/joykit/theme';
import { Check } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';

export const AddedTag = ({ listing }: { listing: AccommodationListingDTO }) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingsPanelTrans = t('listingsPanel');

  if (!listing.isPickedByCouple) {
    return null;
  }

  return (
    <Flex
      position="absolute"
      top="45%"
      left="50%"
      transform="translateX(-50%)"
      zIndex={1}
      justifyContent={'center'}
      alignItems={'center'}
      background={'rgba(255, 255, 255, 0.72)'}
      width={pxToRem(120)}
      paddingY={3}
      gap={1}
      border={'1px solid rgba(255, 255, 255, 0.50)'}
      backdropFilter="blur(21px)"
      borderRadius={'full'}
    >
      <Check size={16} />
      <TextV2 typographyVariant="label2">{listingsPanelTrans.added()}</TextV2>
    </Flex>
  );
};
